import styled from "styled-components";
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	background-color: ${({ theme }) => theme.grayLight};
	border: 1px solid ${({ theme }) => theme.grayDark};
	border-radius: 12px;
	padding: 8px;
	transition: background-color 0.2s ease-out;

	&:hover {
		cursor: pointer;
		background-color: ${({ theme }) => theme.hoverGray};
	}
`;
export const AreaPreview = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 140px;
	width: 100%;
	background-color: ${({ theme }) => theme.grayLight};
	border-radius: 8px;

	> img {
		max-width: 100%;
		max-height: 100%;
		object-fit: cover;
	}
`;

export const AreaContent = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	margin: 0.4rem 0 0 0;
`;

export const useStyles = makeStyles<Theme>((theme) => ({
	buttonDownloadPreview: {
		"&": {
			position: "absolute",
			bottom: "8px",
			right: "8px",
			backgroundColor: "white",
			borderRadius: "50%",
			width: "28px",
			height: "28px",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			cursor: "pointer",
			boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
			color: theme.palette.primary.main,
		},
	},
	buttonBaseDeletePreview: {
		"&": {
			color: theme.palette.primary.main,
			fill: theme.palette.primary.main,
		},
		"& .MuiSvgIcon-root": {
			color: theme.palette.primary.main,
			fill: theme.palette.primary.main,
		},
	},
}));
